// © Microsoft Corporation. All rights reserved.

import React, { useEffect, useRef, useState } from 'react';
import { Stack, Spinner, PrimaryButton } from '@fluentui/react';
import LocalPreview from './LocalPreview';
import LocalSettings from './LocalSettings';
import DisplayNameField from './DisplayNameField';
import {
    VideoDeviceInfo,
    AudioDeviceInfo,
    LocalVideoStream,
    DeviceManager,
    CallAgent,
    CallEndReason,
    ParticipantRole,
    LocalAudioStream
} from '@azure/communication-calling';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import {
    videoCameraIconStyle,
    configurationStackTokens,
    buttonStyle,
    localSettingsContainerStyle,
    mainContainerStyle,
    fullScreenStyle,
    verticalStackStyle
} from './styles/Configuration.styles';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { ParticipantModel, ParticipantInfo, JoinCall, SetUserName,uriCode } from 'Utils/participantInfo';
import { getChats } from 'Utils/chataddapi';

export type TokenResponse = {
    tokenCredential: AzureCommunicationTokenCredential;
    userId: string;
};

export interface ConfigurationScreenProps {
    userId: string;
    groupId: string;
    callAgent: CallAgent;
    deviceManager: DeviceManager;
    setupCallClient(unsupportedStateHandler: () => void): void;
    setupCallAgent(
        displayName: string,
        groupId: string,
        role: string,
        afterSetupHandler: (callAgent: CallAgent, groupId: string) => void
    ): void;
    setGroup(groupId: string): void;
    startCallHandler(): void;
    notJoinedHandler(): void;
    reloadPageHandler(): void;
    unsupportedStateHandler: () => void;
    callEndedHandler: (reason: CallEndReason) => void;
    videoDeviceList: VideoDeviceInfo[];
    audioDeviceList: AudioDeviceInfo[];
    setVideoDeviceInfo(device: VideoDeviceInfo): void;
    setAudioDeviceInfo(device: AudioDeviceInfo): void;
    mic: boolean;
    setMic(mic: boolean): void;
    setLocalVideoStream(stream: LocalVideoStream | undefined): void;
    setLocalAudioStream(stream: LocalAudioStream | undefined): void;
    localVideoRendererIsBusy: boolean;
    videoDeviceInfo: VideoDeviceInfo;
    audioDeviceInfo: AudioDeviceInfo;
    localVideoStream: LocalVideoStream;
    localAudioStream: LocalAudioStream;
    screenWidth: number;
    joinGroup(callAgent: CallAgent, groupId: string): void;
    getToken(): Promise<TokenResponse>;
    createCallAgent(tokenCredential: AzureCommunicationTokenCredential, displayName: string): Promise<CallAgent>;
    registerToCallEvents(
        userId: string,
        callAgent: CallAgent,
        endCallHandler: (reason: CallEndReason) => void
    ): Promise<void>;
    autoJoinCall: boolean;
}

declare global {
    
    var _allowUser: string;
  
}
window._allowUser = 'true';

console.log("COGBEE :: Configuration page called");
export default (props: ConfigurationScreenProps): JSX.Element => {

    //Strat Interview Countdown Timer
    const Ref = useRef<NodeJS.Timeout>();

    // The state for our timer
    const [timer, setTimer] = useState('00:00:00:00');

    const getTimeRemaining = (e: Date) => {
        const total = Date.parse(e.toString()) - Date.parse(new Date().toString());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        const day = Math.floor((total / 1000 / 60 / 60 / 24));

        return {
            total, day, hours, minutes, seconds
        };
    }

    const startTimer = (e: Date) => {

        const { total,day, hours, minutes, seconds }
            = getTimeRemaining(e);

        if (total == 900000) {
            props.reloadPageHandler();
        }

        if (total >= 0) {
            const strTime = (day > 9 ? day : '0' + day) + ' : ' +
                (hours > 9 ? hours : '0' + hours) + ' : ' +
                (minutes > 9 ? minutes : '0' + minutes) + ' : '
                + (seconds > 9 ? seconds : '0' + seconds);
            setTimer(strTime)
        }
    }

    const clearTimer = (e: Date) => {

        if (Ref.current)
            clearInterval(Ref.current);

        const timeoutId = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = timeoutId;
    }

    const getDeadTime = () => {
        let deadline = new Date();
        deadline = new Date();

        const getTimer = modelone.videoInterviewDetail;

        if (getTimer != null) {
            if (getTimer.startTimeLeft != null) {

                //timerArray [0] as Day, [1] as Hours, [2] as Minutes and [3] as Seconds
                const timearr = getTimer.startTimeLeft.split(":");

                if (timearr.length > 0) {
                    deadline.setDate(deadline.getDate() + Number(timearr[0]));
                    deadline.setHours(deadline.getHours() + Number(timearr[1]));
                    deadline.setMinutes(deadline.getMinutes() + Number(timearr[2]));
                    deadline.setSeconds(deadline.getSeconds() + Number(timearr[3]));
                }
            }
        }

        return deadline;
    }

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);




    const spinnerLabel = 'Initializing Meeting...';
    const buttonText = 'Start call';

    //const createUserId = (): string => 'user' + Math.ceil(Math.random() * 1000);

    //const [name, setName] = useState(createUserId());
    //const [emptyWarning, setEmptyWarning] = useState(false);


    const modelone: ParticipantInfo = ParticipantModel();
    console.log("COGBEE :: IN Configuration page");


    let isnotSubmit = true;

    if (modelone.role == "Interviewer" || modelone.role == "Candidate" || modelone.role == "Spoc") {
        isnotSubmit = true;
    }
    else {
        isnotSubmit = false;
    }
    const htmlCode = `<h4>${modelone.role}</h4>`;
    let btnstate = false;

    //const clickButton = () => {
    //    btnstate = true;
    //}


    // alert("createUserId " + createUserId);
    const [name, setName] = useState(modelone.userName);
    const [urole, setRole] = useState(modelone.role);
    //  const role = modelone.role;
    const [emptyWarning, setEmptyWarning] = useState(false);

    const { groupId, setupCallClient, setGroup, unsupportedStateHandler } = props;
    let callAgent: CallAgent;
    useEffect(() => {
        setupCallClient(unsupportedStateHandler);
    }, [setupCallClient, unsupportedStateHandler]);

    useEffect(() => {
        if (props.autoJoinCall) {
            funcJoinCall();
        }
    }, [props.autoJoinCall]);

    const funcJoinCall: () => void = async () => {
        if (name != null && name != "") {

            //localStorage.setItem("overallFeedback", '');
            const loader: HTMLDivElement | null = document.querySelector(".SpinnerSection");

            if (loader != null)
                loader.style.display = "block";

            SetUserName(name);
            if (window.adInfo != null) {
                await props.setAudioDeviceInfo(window.adInfo);
            }

            if (!btnstate) {

                btnstate = true;

                console.log("COGBEE :: inside btnstate" + btnstate);


                //console.log("COGBEE :: outside btnstate " + btnstate);
                let allowUser = 'true';

                allowUser = await Promise.resolve(JoinCall());
                //allowUser = 'true';
                console.log("COGBEE :: ALLOWUSER " + allowUser);

                window._allowUser = allowUser;

                if (allowUser == 'true' || modelone.role == 'Candidate') {
                    if (!name) {
                        setEmptyWarning(true);
                    } else {


                        getChats(uriCode);

                        setEmptyWarning(false);
                        //1. Retrieve a token
                        //const { tokenCredential, userId } = await props.getToken();
                        //2. Initialize the call agent
                        //const nRole = modelone.role as ParticipantRole;



                        //callAgent = await props.createCallAgent(tokenCredential, name + "_" + modelone.role);
                        //3. Register for calling events
                        props.registerToCallEvents(tokenUserId, _callAgent, props.callEndedHandler);
                        //4. Join the call
                        await props.joinGroup(_callAgent, groupId);
                        props.startCallHandler();
                        setGroup(groupId);
                    }


                }
                else {
                    props.notJoinedHandler()
                }
            }
        }
    }

    return (
        <Stack className={mainContainerStyle} horizontalAlign="center" verticalAlign="center">
            {props.deviceManager && isnotSubmit ? (
                <Stack
                    className={props.screenWidth > 750 ? fullScreenStyle : verticalStackStyle}
                    horizontal={props.screenWidth > 750}
                    horizontalAlign="center"
                    verticalAlign="center"
                    tokens={props.screenWidth > 750 ? configurationStackTokens : undefined}
                >
                    <LocalPreview
                        mic={props.mic}
                        setMic={props.setMic}
                        setLocalVideoStream={props.setLocalVideoStream}
                        setLocalAudioStream={props.setLocalAudioStream}
                        videoDeviceInfo={props.videoDeviceInfo}
                        audioDeviceInfo={props.audioDeviceInfo}
                        localVideoStream={props.localVideoStream}
                        localAudioStream={props.localAudioStream}
                        videoDeviceList={props.videoDeviceList}
                        audioDeviceList={props.audioDeviceList}
                    />
                    <Stack className={localSettingsContainerStyle}>
                        <DisplayNameField setName={setName} name={name} setEmptyWarning={setEmptyWarning} isEmpty={emptyWarning} />
                        <div>
                            <LocalSettings
                                videoDeviceList={props.videoDeviceList}
                                audioDeviceList={props.audioDeviceList}
                                audioDeviceInfo={props.audioDeviceInfo}
                                videoDeviceInfo={props.videoDeviceInfo}
                                setVideoDeviceInfo={props.setVideoDeviceInfo}
                                setAudioDeviceInfo={props.setAudioDeviceInfo}
                                deviceManager={props.deviceManager}
                            />
                        </div>
                        <div>
                            <div className="SpinnerSection" style={{ display: "none" }}>
                                <Spinner className="btnStartLoader"></Spinner>
                                <div className="btnStartLoader" style={{ color: "#0078d4", bottom: "50px", right: "50px" }}>
                                    Connecting...
                                </div> 
                            </div>
                            <PrimaryButton
                                className={buttonStyle}
                                disabled={btnstate}
                                id="btnStartCall"
                                onClick={async (): Promise<void> => {
                                    await funcJoinCall();
                                }}
                            >
                                <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" />
                                {buttonText}
                            </PrimaryButton>
                        </div>
                    </Stack>
                </Stack>
            ) : (
                isnotSubmit ? (
                    <Spinner label={spinnerLabel} ariaLive="assertive" labelPosition="top" />
                    ) : (<div dangerouslySetInnerHTML={{ __html: htmlCode }} />)
            )}
        </Stack>
    );
};
